import React, { forwardRef, useMemo, useState } from 'react';

import { CodeInputWrapper, HiddenInput, Segment, SegmentsWrapper } from './CodeInput-styled-components';

interface CodeInputProps {
  maxLength: number;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading?: boolean;
}

export const CodeInput = forwardRef<HTMLInputElement, CodeInputProps>((props, ref) => {
  const {
    maxLength,
    value,
    onChange,
    isLoading,
  } = props;

  const [isInputFocused, setIsInputFocused] = useState(false);

  const valueAsArray = useMemo(
    () => value.split(''),
    [value],
  );

  const segmentedInputs = useMemo(() =>
    Array.from({ length: maxLength }, (_, index) => (
      <Segment
        key={index}
        $isFocused={isInputFocused && index === valueAsArray.length}
      >
        {valueAsArray[index]}
      </Segment>
    )), [maxLength, valueAsArray, isInputFocused]);

  return (
    <CodeInputWrapper $isLoading={isLoading}>
      <SegmentsWrapper aria-hidden="true">
        {segmentedInputs}
      </SegmentsWrapper>

      <HiddenInput
        ref={ref}
        onFocus={() => setIsInputFocused(true)}
        onBlur={() => setIsInputFocused(false)}
        onChange={onChange}
        value={value}
        maxLength={maxLength}
        $isLoading={isLoading}
      />
    </CodeInputWrapper>
  );
});

CodeInput.displayName = 'CodeInput';
